import { RootState } from "../Store";

export const SELECT_APPLICATIONS = (state: RootState) =>
  state.applicationsAllSlice.applications;

export const SELECT_APPLICATIONS_TYPE_BG = (state: RootState) =>
  state.applicationsAllSlice.typeBG;

export const SELECT_APPLICATIONS_LAST_PAGE = (state: RootState) =>
  state.applicationsAllSlice.last_page;

export const SELECT_IS_NEW_MESSAGE = (id: number) => (state: RootState) => {
  const application = state.applicationsAllSlice.applications.find(
    (app) => app.id === id
  );

  return application?.isNewMessage || false;
};

export const SELECT_FILTER = (state: RootState) =>
  state.applicationsAllSlice.filter;
